import React, { useState } from "react";
import General from "./General";
import Reports from "./Reports";

function Admin() {
  const [selected, setSelected] = useState("general");
  return (
    <div className="w-screen max-w-screen-lg mx-auto flex">
      <div
        id="nav-menu"
        class="flex flex-col justify-between border-r bg-white w-52 min-h-full"
      >
        <div class="px-4">
          <nav aria-label="Main Nav" class="flex flex-col space-y-1">
            <div
              class={
                "flex items-center gap-2 rounded-lg px-4 py-2 cursor-pointer text-gray-500 hover:bg-gray-100 " +
                (selected === "general" ? " bg-gray-100 text-gray-700" : "")
              }
              onClick={() => setSelected("general")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 opacity-75"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>

              <span class="text-sm font-medium"> General </span>
            </div>

            <div
              class={
                "flex items-center gap-2 rounded-lg px-4 py-2  hover:bg-gray-100 hover:text-gray-700 cursor-pointer " +
                (selected === "reports"
                  ? " bg-gray-100 text-gray-700"
                  : "text-gray-500")
              }
              onClick={() => setSelected("reports")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 opacity-75"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                />
              </svg>

              <span class="text-sm font-medium"> Reports </span>
            </div>
          </nav>
        </div>
      </div>
      <div>{selected === "general" ? <General /> : <Reports />}</div>
    </div>
  );
}

export default Admin;
